import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "call_in",
  "use": "call_in-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"call_in\">\r\n<path d=\"M2,11h6c0.552,0,1-0.448,1-1S8.552,9,8,9H4.414l6.293-6.293c0.391-0.391,0.391-1.023,0-1.414\r\n\tC10.512,1.098,10.256,1,10,1S9.488,1.098,9.293,1.293L3,7.586V4c0-0.552-0.448-1-1-1C1.447,3,1,3.448,1,4v6C1,10.552,1.447,11,2,11z\r\n\t\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol